import React, { Component } from 'react'
import { displayOddsType, currencyToText, SPORTS } from 'utils/converters'
import { firebaseRef } from 'config'
import moment from 'moment'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import 'css/livefeed.less'

const LivefeedItem = (props) => {
  const {
    oddsType,
    wager,
    createdAt,
    currency,
    odds,
    oddsTypeCondition,
    output,
    match: { homeTeam, awayTeam },
  } = props
  return (
    <div className='livefeed-item clearfix'>
      <span className='icon'>
        <i className={SPORTS[props.sportId].icon}></i>
      </span>
      <div className='info'>
        <div>
          <span className='highlighted'>{ homeTeam }</span>
          <span> vs </span>
          <span className='highlighted'>{ awayTeam }</span>
          <span className='pull-right'>{ moment(createdAt).fromNow() }</span>
        </div>
        <span className='highlighted'>{ currencyToText(wager, currency) }</span>
        <span> on </span>
        <span className='highlighted'>{ displayOddsType(oddsType, output, oddsTypeCondition)}</span>
        <span> @ </span>
        <span className='highlighted'>{ odds }</span>
      </div>
    </div>
  )
}
const Livefeed = (props) => {
  return (
    <ReactCSSTransitionGroup className='livefeed-list' component='div'
      transitionName='livefeed'
      transitionEnterTimeout={500} transitionLeaveTimeout={300}
      transitionAppear={true} transitionAppearTimeout={500}>
      { props.items.map((item) => <LivefeedItem key={item.id} {...item} />)}
    </ReactCSSTransitionGroup>
  )
}

const _updateInterval = 1000 * 60
class LivefeedContainer extends Component {
  constructor(props) {
    super(props)
    this.ref = firebaseRef.child('userbets').orderByChild('createdAt').limitToLast(6)
    this.onNewBet = this.onNewBet.bind(this)
    this.onRemovedBet = this.onRemovedBet.bind(this)
    this.lastUpdated = Date.now()
    this.state = {
      bets: []
    }

    this.interval = setInterval(() => {
      if (Date.now() - this.lastUpdated > _updateInterval) {
        this.forceUpdate()
      }
    }, _updateInterval)
  }

  componentDidUpdate() {
    this.lastUpdated = Date.now()
  }

  componentDidMount() {
    this.ref.on('child_added', this.onNewBet)
    this.ref.on('child_removed', this.onRemovedBet)
  }

  componentWillUnmount() {
    this.ref.off('child_added', this.onNewBet)
    this.ref.off('child_removed', this.onRemovedBet)
    clearInterval(this.interval)
  }

  onNewBet(snap) {
    let bet = snap.val()
    if (bet.user !== this.props.user.id && bet.edge > 1) {
      this.setState({
        bets: [...this.state.bets, Object.assign({}, bet, {id: snap.key()})]
      })
    }
  }

  onRemovedBet(snap) {
    this.setState({
      bets: this.state.bets.filter(bet => bet.id !== snap.key())
    })
  }

  render() {
    const bets = this.state.bets.sort((a, b) => b.createdAt - a.createdAt)
    return (
      <div className='panel livefeed-panel'>
        <header className='panel-heading'>
          Live feed
          <span className='pull-right'>From the community</span>
        </header>
        <div className='panel-body'>
          <Livefeed items={bets} />
        </div>
      </div>
    )
  }
}

export default LivefeedContainer



/** WEBPACK FOOTER **
 ** ./src/components/dashboard/Livefeed.js
 **/